import parallelLimit from 'async/parallelLimit';
import { denormalisedResponseEntities } from 'util/data';

const queryAllPages = async ({ sdkModel, params = {} }) => {
  const responses = [];
  const query = async (page = 1) => {
    const response = await sdkModel.query({
      ...params,
      page,
    });
    const responseData = denormalisedResponseEntities(response);
    responses.push(...responseData);
    return response;
  };

  const firstResponse = await query();

  const { meta } = firstResponse?.data || {};

  const remainingPages = Array.from({
    length: Math.min(meta.totalPages, meta.paginationLimit || meta.totalPages) - 1,
  }).map((_, index) => index + 2);

  if (remainingPages.length > 0) {
    await parallelLimit(
      remainingPages.map((page) => async () => {
        await query(page);
      }),
      4
    );
  }

  return responses;
};

export default queryAllPages;
